const basico4 = {
    titulo: `JavaScript: comentarios en el código fuente`,
    problemas: [
      {
        codigo: 1,
        descripcion: `Los comentarios son anotaciones que se hacen en el código fuente para recordar e informar a otros programadores sobre cómo está programado. Facilitan la vida a los programadores que modificarán el código en un futuro.
Disponemos comentarios de una sola línea mediante dos caracteres: //
<pre>
//Calcula el área de un triángulo
let base = 5
let altura = 6
let area = base * altura / 2
console.log(area)
</pre>        
Todo lo que se indica luego de // es un comentario y lo va a obviar el intérprete de JavaScript, puede estar inclusive en una línea de código:
<pre>
let base = 5 // báse del triángulo
</pre>
  `,
        programa: `//Calcula el área de un triángulo
let base = 5
let altura = 6
let area = base * altura / 2
console.log(area)`,
        solucion: "15"
      },{
        codigo: 2,
        descripcion: `Para disponer comentarios más extensos se utiliza los comentarios de múltiples líneas:
<pre>
/* Calcular el área de un círculo.
   Se conoce el radio del círculo */
let radio = 5
let areaCirculo = 3.1416 * radio * radio
console.log(areaCirculo)
</pre>
Como vemos la sintaxis de los comentarios de múltiples líneas comienza con los caracteres /* y termina con los caracteres */
Hay que decir que no hemos realizado ningún programa que requiera disponer comentarios, debido a su simpleza. No es conveniente disponer comentarios que sean obvios.`,
        programa: `/*
   Se tienen 3 notas de distintos alumnos.
   Calcular el promedio de notas.
*/
let nota1 = 10
let nota2 = 8
let nota3 = 9
let promedio = (nota1 + nota2 + nota3) / 3
console.log(promedio)`,
        solucion: "9"
      }
    ]
  }
  
  export default basico4;